import { useEffect, useState, useCallback } from 'react';
import {
  getState,
  subscribe,
  promptInstall,
} from '../services/pwaInstall';

// React hook around the PWA install singleton.
// Returns install state and a `promptInstall` action that resolves to the
// user-choice outcome ('accepted' | 'dismissed' | 'unavailable').
const usePWAInstall = () => {
  const [state, setState] = useState(getState);

  useEffect(() => {
    const unsubscribe = subscribe(setState);
    return unsubscribe;
  }, []);

  const install = useCallback(() => promptInstall(), []);

  return { ...state, promptInstall: install };
};

export default usePWAInstall;
